import { useMemo } from 'react';
import classNames from 'classnames';

import { BatchDataStatus } from 'configs/constants';
import useMemoSelector from 'hooks/useMemoSelector';
import { getIsDarkModeEnabled } from 'store/selectors/general';

import testIds from './testIds';
import useStyles from './styles';

interface IGridItemLoader {
  status: BatchDataStatus;
}

const loaderSVGPaths: { [key in BatchDataStatus]: string } = {
  in_progress: 'M17.5,42.3l23.2-23.2L23.9,35.9l-17-17c3.4-8.1,11.3-13.7,20.6-13.7c12.3,0,22.3,10,22.3,22.3 s-10,22.3-22.3,22.3S5.2,39.8,5.2,27.5c0-3.1,0.6-6,1.7-8.6',
  done: 'M17.5,42.3l23.2-23.2L23.9,35.9l-17-17c3.4-8.1,11.3-13.7,20.6-13.7c12.3,0,22.3,10,22.3,22.3 s-10,22.3-22.3,22.3S5.2,39.8,5.2,27.5c0-3.1,0.6-6,1.7-8.6',
  error: 'M15.8,39.2l23.4-23.4v23.4L11.7,11.7c4-4,9.6-6.5,15.8-6.5c12.3,0,22.3,10,22.3,22.3s-10,22.3-22.3,22.3 S5.2,39.8,5.2,27.5c0-6.2,2.5-11.8,6.6-15.8',
  pending: '',
};

const GridItemLoader = ({ status }: IGridItemLoader) => {
  const isDarkModeEnabled = useMemoSelector(getIsDarkModeEnabled);
  const classes = useStyles({ isDarkMode: isDarkModeEnabled });

  const [isDone, isProgress, isError] = useMemo(() => [
    status === BatchDataStatus.DONE,
    status === BatchDataStatus.IN_PROGRESS,
    status === BatchDataStatus.ERROR,
  ], [status]);

  const loaderSVGPath = useMemo(() => loaderSVGPaths[status], [status]);

  return (
    <div
      className={classNames(classes.progressLoadingWrap, {
        [classes.onProgressState]: isProgress,
        [classes.onSuccessState]: isDone,
        [classes.onErrorState]: isError,
      })}
    >
      <div
        className={classNames(classes.progressLoadingBox, {
          [classes.loaderProgress]: isProgress,
          [classes.loaderSuccess]: isDone,
          [classes.loaderError]: isError,
        })}
        data-testid={testIds.loaderBox}
      >
        <svg className={classes.loader} viewBox="0 0 55 55" xmlSpace="preserve" data-testid={testIds.loaderSvg}>
          <path className={classes.loaderPath} d={loaderSVGPath} />
        </svg>
      </div>
    </div>
  );
};

export default GridItemLoader;
